export default class Geometry {
  columnWidth = 18 // in
  wallWidth = 8 // in
  footingWidth = 134 //in
  footingThickness = 32 //in

  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onUpdate(detail) {
    this.columnWidth = detail.columnWidth
    this.wallWidth = detail.wallWidth
    this.footingWidth = detail.footingWidth
    this.footingThickness = detail.footingThickness

    document.dispatchEvent(new CustomEvent('geometry-changed'))
  }
}